import { Document, Page, Text, View, StyleSheet, Image, pdf } from '@react-pdf/renderer';
import React from 'react';
import { fromByteArray } from "base64-js"
import TextLogo from "assets/images/akowe_logo.png";
import Logo from "assets/images/logo.svg";

export async function generateDownloadLink(generatedPDF, candidate) {
    try {
        const blob = await pdf(generatedPDF).toBlob();
        const blobURL = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = blobURL;
        link.download = candidate + 'full-report.pdf';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        return true;
    } catch (error) {
        console.log(error)
        return false
    }
}


const bufferToBase64 = (buffer) => {
    // const binary = String.fromCharCode(...buffer.data);
    const binary = fromByteArray(buffer);
    return `data:image/png;base64,${btoa(binary)}`;

};


function arrayBufferToBase64(arrayBuffer) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(new
            Blob([arrayBuffer]));
    });
}


// highlight and yearbook are of the structure {type:"Buffer",data:[Uint8Array]}

export function DownloadablePDF({ certificate, highlightedPage, yearBook }) {

    if (!certificate) return;

    const yeaBookImage = yearBook && yearBook.data ? arrayBufferToBase64(new Uint8Array(yearBook.data)) : null;

    const highlightPageImage = highlightedPage && highlightedPage.data ? arrayBufferToBase64(new Uint8Array(highlightedPage.data)) : null;

    const styles = StyleSheet.create({
        page: {
            padding: 40,
            display: "flex",
            flexDirection: "column",
            fontFamily: "Helvetica",
        },
        header: {
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            paddingBottom: 20,
            borderBottomWidth: 1,
            borderBottomColor: "#666666",
            borderBottomStyle: "solid",
            marginBottom: 30,
        },
        logoSection: {
            width: 100,
        },
        headerTextSection: {
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-end",
        },
        headerTitle: {
            color: "#008081",
            fontSize: 22,
            fontWeight: "bold",
            fontFamily: "Helvetica-Bold",
            marginBottom: 2,
        },
        headerSubtitle: {
            color: "#008081",
            fontSize: 15,
            fontFamily: "Helvetica",
        },
        titleSection: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            marginBottom: 20,
        },
        mainTitle: {
            fontSize: 16,
            fontWeight: "bold",
            fontFamily: "Helvetica-Bold",
            marginBottom: 6,
            color: "#000",
        },
        subTitle: {
            fontSize: 12,
            color: "#000",
        },
        table: {
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            borderStyle: 'solid',
            borderWidth: 1,
            borderColor: '#cccccc',
            marginBottom: 30,
        },
        tableRow: {
            display: 'flex',
            flexDirection: 'row',
            borderBottomWidth: 1,
            borderBottomColor: '#cccccc',
            minHeight: 40,
            alignItems: 'stretch',
        },
        tableRowLast: {
            display: 'flex',
            flexDirection: 'row',
            minHeight: 40,
            alignItems: 'stretch',
        },
        tableColLabel: {
            width: '35%',
            paddingLeft: 15,
            paddingVertical: 10,
            borderRightWidth: 1,
            borderRightColor: '#cccccc',
            justifyContent: 'center',
        },
        tableColValue: {
            width: '65%',
            paddingLeft: 15,
            paddingVertical: 10,
            justifyContent: 'center',
        },
        labelText: {
            fontSize: 11,
            color: '#000',
        },
        valueText: {
            fontSize: 11,
            fontWeight: "bold",
            fontFamily: "Helvetica-Bold",
            color: '#000',
        },
        disclaimerTitle: {
            fontSize: 14,
            fontWeight: "bold",
            fontFamily: "Helvetica-Bold",
            marginBottom: 8,
            color: '#000',
        },
        disclaimerText: {
            fontSize: 9,
            lineHeight: 1.5,
            marginBottom: 10,
            color: '#000',
            textAlign: "justify",
        }
    });

    return (
        <>
            <Document>
                <Page size={'A4'} style={styles.page}>
                    <View style={styles.header}>
                        <View style={styles.logoSection}>
                            <Image src={TextLogo} style={{ width: "100%", height: "auto" }} />
                        </View>
                        <View style={styles.headerTextSection}>
                            <Text style={styles.headerTitle}>Akowe Verify</Text>
                            <Text style={styles.headerSubtitle}>Instant Verification of Academic Records.</Text>
                        </View>
                    </View>

                    <View style={styles.titleSection}>
                        <Text style={styles.mainTitle}>Academic Records Verification Report</Text>
                        <Text style={styles.subTitle}>Credential Details</Text>
                    </View>

                    <View style={styles.table}>
                        <View style={styles.tableRow}>
                            <View style={styles.tableColLabel}>
                                <Text style={styles.labelText}>Name</Text>
                            </View>
                            <View style={styles.tableColValue}>
                                <Text style={styles.valueText}>{certificate?._doc?.name}</Text>
                            </View>
                        </View>

                        <View style={styles.tableRow}>
                            <View style={styles.tableColLabel}>
                                <Text style={styles.labelText}>Institution</Text>
                            </View>
                            <View style={styles.tableColValue}>
                                <Text style={styles.valueText}>{certificate?.institution?.institutionName}</Text>
                            </View>
                        </View>

                        <View style={styles.tableRow}>
                            <View style={styles.tableColLabel}>
                                <Text style={styles.labelText}>Course</Text>
                            </View>
                            <View style={styles.tableColValue}>
                                <Text style={styles.valueText}>{certificate?._doc?.course}</Text>
                            </View>
                        </View>

                        <View style={styles.tableRow}>
                            <View style={styles.tableColLabel}>
                                <Text style={styles.labelText}>Degree</Text>
                            </View>
                            <View style={styles.tableColValue}>
                                <Text style={styles.valueText}>{certificate?._doc?.degree}</Text>
                            </View>
                        </View>

                        <View style={styles.tableRow}>
                            <View style={styles.tableColLabel}>
                                <Text style={styles.labelText}>Grade</Text>
                            </View>
                            <View style={styles.tableColValue}>
                                <Text style={styles.valueText}>{certificate?._doc?.grade}</Text>
                            </View>
                        </View>

                        <View style={styles.tableRowLast}>
                            <View style={styles.tableColLabel}>
                                <Text style={styles.labelText}>Year</Text>
                            </View>
                            <View style={styles.tableColValue}>
                                <Text style={styles.valueText}>{certificate?._doc?.year}</Text>
                            </View>
                        </View>
                    </View>

                    <View>
                        <Text style={styles.disclaimerTitle}>Disclaimer</Text>
                        <Text style={styles.disclaimerText}>
                            This report is based on information obtained from primary and secondary sources considered reliable at the time of verification. Where direct confirmation from issuing institutions is unavailable, findings may rely on corroborated data and are reflected in the verification status provided.
                        </Text>
                        <Text style={styles.disclaimerText}>
                            While Akowe applies defined verification standards, it does not guarantee the completeness or absolute accuracy of all information, which may be subject to change.
                        </Text>
                        <Text style={styles.disclaimerText}>
                            This report is provided for due diligence purposes only. Decisions based on its contents remain the responsibility of the requesting organization, and Akowe shall not be liable for any outcomes arising from its use.
                        </Text>
                    </View>
                </Page>

                {yeaBookImage &&
                    <Page>
                        <Image src={yeaBookImage} />
                    </Page>
                }
                {highlightPageImage &&
                    <Page>
                        <Image src={highlightPageImage} />
                    </Page>
                }
            </Document>
        </>
    )
}